import { defineComponent as b, computed as d, createElementBlock as u, openBlock as y, mergeProps as c, unref as a, renderSlot as k } from "vue";
import { useOUIAProps as B } from "./packages/core/dist/helpers/ouia.js";
import i from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table.js";
import v from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/InlineEdit/inline-edit.js";
import { useChildrenTracker as C } from "@vue-patternfly/core";
import { TableTrKey as w } from "./common.js";
const R = ["hidden", "tabindex", "aria-label"], S = /* @__PURE__ */ b({
  name: "PfTr",
  __name: "Tr",
  props: {
    hidden: { type: Boolean },
    expanded: { type: Boolean, default: void 0 },
    editable: { type: Boolean },
    clickable: { type: Boolean },
    selected: { type: Boolean },
    striped: { type: Boolean },
    borderRow: { type: Boolean },
    selectable: { type: Boolean },
    resetOffset: { type: Boolean },
    ariaLabel: {},
    onClick: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(t) {
    const o = t, s = B({ id: o.ouiaId, safe: o.ouiaSafe }), r = d(() => o.hidden || o.expanded !== void 0 && !o.expanded), p = d(() => {
      if (o.ariaLabel)
        return o.ariaLabel;
      if (!(!o.selectable || r.value))
        return o.selected ? "Row selected" : "";
    });
    C(w);
    function f(e) {
      o.onClick && (e.key === "Enter" || e.key === " ") && (o.onClick(e), e.preventDefault());
    }
    return (e, l) => (y(), u("tr", c(a(s), {
      class: [a(i).tableTr, {
        [a(i).tableExpandableRow]: e.expanded !== void 0,
        [a(i).modifiers.expanded]: e.expanded,
        [a(v).modifiers.inlineEditable]: e.editable,
        [a(i).modifiers.clickable]: e.clickable,
        [a(i).modifiers.selected]: e.selected,
        [a(i).modifiers.striped]: e.striped,
        [a(i).modifiers.borderRow]: e.borderRow,
        [a(i).modifiers.firstCellOffsetReset]: e.resetOffset
      }],
      hidden: r.value,
      tabindex: e.clickable ? 0 : e.$attrs.tabindex,
      "aria-label": p.value,
      onClick: l[0] || (l[0] = (m) => {
        var n;
        return (n = e.onClick) == null ? void 0 : n.call(e, m);
      }),
      onKeydown: f
    }), [
      k(e.$slots, "default")
    ], 16, R));
  }
});
export {
  S as default
};
